module.exports = __webpack_public_path__ + "img/Website_Screenshot_2.c57a3ac8.jpg";